import { Auth } from 'aws-amplify'
import lodash from 'lodash';

export default class Authentication {

    static signIn(username, password) {
        return Auth.signIn(username, password);
    }

    static signOut() {
        return Auth.signOut();
    }

    static getCurrentUser() {
        return Auth.currentAuthenticatedUser();
    }

    static forgotPassword(username) {
        return Auth.forgotPassword(username);
    }

    static forgotPasswordSubmit(username, code, newPassword) {
        return Auth.forgotPasswordSubmit(username, code, newPassword);
    }

    static changeUserPassword(user, currentPassword, newPassword) {
        return Auth.changePassword(user, currentPassword, newPassword);
    }

    static completeNewPassword(user, newPassword) {
        return Auth.completeNewPassword(user, newPassword);
    }

    static userIsAdmin(user) {
        const userGroups = user.signInUserSession.accessToken.payload["cognito:groups"];
        const adminGroup = lodash.find(userGroups || [], group => group === 'admin');
        return adminGroup ? true : false;
    }
}